import {add_error, clear_error} from '../shared/form_errors.js'
import moment from "moment";
import * as bootstrap from 'bootstrap';

document.addEventListener('turbo:load', function () {
    add_listeners()
})
document.addEventListener('DOMContentLoaded', function () {
    add_listeners()
})

function add_listeners() {
    window.__appJsBooted = true;

    trackPageView();

    if (shouldCollapseSidebar()) {
        collapseMenu();
    } else {
        expandMenu();
    }

    setUpSidebarScrollHints();

    document.querySelectorAll('.menu-toggle').forEach(element => element.addEventListener('click', (event) => {
        const sidebar = document.getElementById('sidebar-container');
        if (sidebar && sidebar.classList.contains('collapsed')) {
            expandMenu();
        } else {
            collapseMenu();
        }
    }));

    // Close off-canvas menu when any link inside it is clicked -- except
    // the scroll-hint chevrons, which navigate within the still-open menu
    // rather than away from it.
    const offcanvasElement = document.getElementById('mobileSidebar');
    if (offcanvasElement) {
        offcanvasElement.querySelectorAll('a:not(.sidebar-scroll-hint)').forEach(link => {
            link.addEventListener('click', () => {
                const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement);
                if (bsOffcanvas) {
                    bsOffcanvas.hide();
                }
            });
        });
        // The off-canvas panel is `display: none` until shown, so its
        // content can't be measured (scrollHeight reads 0) until then.
        offcanvasElement.addEventListener('shown.bs.offcanvas', updateSidebarScrollHints);
    }

    window.addEventListener('resize', function() {
        if (shouldCollapseSidebar()) {
            collapseMenu();
        } else {
            expandMenu();
        }
        updateSidebarScrollHints();
    });

    document.addEventListener('ajax:complete', event => {
        const request = event.detail[0];
        const msg = request.getResponseHeader("X-Message");
        let alertType = 'alert-success';
        if (request.getResponseHeader("X-Message-Type").includes("error")) {
            alertType = 'alert-danger';
        }
        if (!request.getResponseHeader("X-Message-Type").startsWith("keep")) {
            if (msg) {
                document.getElementById("flash_hook").outerHTML = `<div id='flash_hook'> <p>&nbsp;</p> <div class='row'> <div class='span10 offset1'> <div class='alert ${alertType}'> <button type='button' class='close' data-dismiss='alert'>&times;</button>${msg}</div> </div> </div> </div>`;
            } else {
                document.getElementById("flash_hook").outerHTML = "<div id='flash_hook'></div>";
            }
        }
    });
    document.querySelectorAll('.count-text').forEach(element => element.addEventListener('keyup', (event) => {
        const group = event.target.closest('.input-group');
        const counter = group && group.querySelector('.counter');
        if (!counter) return;
        const max_length = parseInt(counter.dataset.max) - counter.textContent.length;
        const cur_count = max_length - event.target.value.length;
        if (cur_count <= 0) {
            counter.style.color = 'red';
        } else {
            counter.style.color = 'lightgray';
        }
        counter.textContent = 'Characters left: ' + String(cur_count);
    }));

    document.querySelectorAll('[id$=color_swatch]').forEach(element => {
        element.addEventListener('change', (event) => {
            setSwatchColor(event.target);
        });
    });

    const dateInputs = document.querySelectorAll('input[type="date"]');
    dateInputs.forEach(input => {
        input.addEventListener('blur', () => {
            if (input.value !== '') {
                moment(input.value, "YYYY-MM-DD", true).isValid() ? clear_error(input) : add_error(input, 'Invalid Date');
            }
        });
    });

    // trackMenuClick is a stable top-level function reference, so calling
    // addEventListener with it again on every turbo:load/DOMContentLoaded
    // (add_listeners runs on both, every navigation) is a no-op rather than
    // stacking up duplicate listeners -- the same reasoning documented below
    // for add_listeners() itself.
    document.addEventListener('click', trackMenuClick);
}

// A badge (the pending-accounts/pending-tasks count) or an icon can sit
// inside the same link/button as the label -- strip both so the tracked
// label is just the stable text ("People"), not "3People" that would
// fragment the same menu item into a different value per click depending
// on whatever count happened to be showing.
function menuLabelText(el) {
    const clone = el.cloneNode(true);
    clone.querySelectorAll('sup, i').forEach(node => node.remove());
    return clone.textContent.replace(/\s+/g, ' ').trim();
}

// A collapsible group's own label lives on its toggle button, not on the
// sub-link that was actually clicked -- found via the same data-bs-target
// relationship Bootstrap itself relies on to open the group, not by
// guessing at sibling order.
function menuSectionLabel(link) {
    const collapseAncestor = link.closest('.collapse[id]');
    if (!collapseAncestor) return menuLabelText(link);

    const toggle = document.querySelector(`[data-bs-target="#${collapseAncestor.id}"]`);
    return toggle ? menuLabelText(toggle) : null;
}

// Scoped to the two sidebar containers specifically -- other collapsible
// panels elsewhere in the app (search filter cards, etc.) use the same
// data-bs-target pattern and would otherwise get misread as a menu click.
function trackMenuClick(event) {
    if (typeof gtag !== 'function') return;
    if (!event.target.closest('#sidebar-container, #mobileSidebar')) return;

    const link = event.target.closest('a[href]');
    if (!link) return;

    const menuItem = menuSectionLabel(link);
    if (!menuItem) return;

    gtag('event', 'menu_click', { menu_item: menuItem, link_url: link.getAttribute('href') });
}

// add_listeners() runs on both turbo:load and DOMContentLoaded so the
// initial page load is covered even if turbo:load fires before this script
// finishes registering its listener (a real race against the non-deferred
// application.js pack that boots Turbo). Both can fire for the same URL, so
// track the last-reported URL and skip the repeat rather than double-count
// a single page_view in GA.
function trackPageView() {
    if (typeof gtag !== 'function') return;
    if (window.__gaLastTrackedUrl === window.location.href) return;
    window.__gaLastTrackedUrl = window.location.href;
    gtag('event', 'page_view', {
        page_location: window.location.href,
        page_title: document.title,
    });
}

function setSwatchColor(element) {
    const color = element.value;
    const group = element.closest('.input-group');
    const colorSwatch = group.querySelector('.color-swatch');
    colorSwatch.style.backgroundColor = color;
}
function isSmallScreen() {
    return window.matchMedia("(max-width: 767.98px)").matches; // 767.98px is Bootstrap's md breakpoint
}

// Below this width, a full-width sidebar eats too much of the available
// space, so default to icon-only until the user asks to expand it via the
// toggle. The sidebar itself is a fixed width either way now (see
// application.scss), so this is a proportion preference, not a fix for
// clipped/wrapped text.
function shouldCollapseSidebar() {
    return window.matchMedia("(max-width: 1199.98px)").matches; // Bootstrap's lg breakpoint
}

function collapseMenu() {
    const sidebar = document.getElementById('sidebar-container');
    if (sidebar) sidebar.classList.add('collapsed');
    const collapseMenuEl = document.getElementById('collapse-menu');
    if (collapseMenuEl) {
        collapseMenuEl.classList.remove('d-none');
        collapseMenuEl.setAttribute('aria-expanded', 'false');
    }
    const fullMenuEl = document.getElementById('full-menu');
    if (fullMenuEl) {
        fullMenuEl.classList.add('d-none');
        fullMenuEl.setAttribute('aria-expanded', 'false');
    }
}
function expandMenu() {
    const sidebar = document.getElementById('sidebar-container');
    if (sidebar) sidebar.classList.remove('collapsed');
    const fullMenuEl = document.getElementById('full-menu');
    if (fullMenuEl) {
        fullMenuEl.classList.remove('d-none');
        fullMenuEl.setAttribute('aria-expanded', 'true');
    }
    const collapseMenuEl = document.getElementById('collapse-menu');
    if (collapseMenuEl) {
        collapseMenuEl.classList.add('d-none');
        collapseMenuEl.setAttribute('aria-expanded', 'true');
    }
}

// The -1 epsilon on hasMoreBelow absorbs sub-pixel rounding that can
// otherwise leave scrollTop reading a fraction short of the true bottom
// even when a container is genuinely scrolled all the way there.
function hasMoreBelow(container) {
    return container.scrollHeight - container.clientHeight - container.scrollTop > 1;
}
function hasMoreAbove(container) {
    return container.scrollTop > 1;
}

// Each hint sits next to (not inside) the element that actually scrolls --
// see the .sidebar-scroll-area comment in application.scss for why -- so
// the scrolling element is a sibling, found via the hint's own parent.
function sidebarScrollAreaFor(hint) {
    return hint.parentElement ? hint.parentElement.querySelector('.sidebar-scroll-area') : null;
}

// Shows/hides the down icon (pinned to the bottom of its container) and
// the up icon (pinned to the top) independently, based on whether there's
// actually content scrolled out of view in that specific direction.
function updateSidebarScrollHints() {
    document.querySelectorAll('.sidebar-scroll-hint-down').forEach(hint => {
        const scrollArea = sidebarScrollAreaFor(hint);
        if (scrollArea) hint.classList.toggle('visible', hasMoreBelow(scrollArea));
    });
    document.querySelectorAll('.sidebar-scroll-hint-up').forEach(hint => {
        const scrollArea = sidebarScrollAreaFor(hint);
        if (scrollArea) hint.classList.toggle('visible', hasMoreAbove(scrollArea));
    });
}

// Wires up a scroll listener per hint (so it shows/hides as the user
// actually scrolls) and a click handler that jumps straight to that
// icon's end of the menu, then runs an initial check. Container content/
// height can also change later -- viewport resize, the off-canvas panel
// opening -- so those spots call updateSidebarScrollHints() directly
// rather than relying on this initial pass alone.
function setUpSidebarScrollHints() {
    document.querySelectorAll('.sidebar-scroll-hint').forEach(hint => {
        const scrollArea = sidebarScrollAreaFor(hint);
        if (!scrollArea) return;
        scrollArea.addEventListener('scroll', updateSidebarScrollHints);
        hint.addEventListener('click', (event) => {
            // Plain `<a href="#">` icons rather than <button>s -- prevent
            // the default same-page anchor jump so only the smooth
            // scrollTo below runs.
            event.preventDefault();
            const top = hint.classList.contains('sidebar-scroll-hint-up') ? 0 : scrollArea.scrollHeight;
            scrollArea.scrollTo({top, behavior: 'smooth'});
        });
    });
    updateSidebarScrollHints();
}







